import { computed, defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";

import { ReportService } from "../../../../../services/report-service";
import { TaskService } from "../../../../../services/task.service";
import { formatDate } from "../../../../../common/vue-helpers/modifiers/value-modifier";
import { NavigationService } from "../../../../../services/navigation.service";
import { FrequencyStatuses } from "../../../../../enums/FrequencyStatusesEnum";
import { PAGE_FAIL_RESPONSE } from "../../../../CentralIntake/Inquiry/CentralInquiry";
import { IFrequencyWatchWeeklyRequest } from "../../../../../resources-vue/vue-interfaces/i-reports";
import { ApplicationEnum } from "../../../../../enums/ApplicationEnum";
import { ParentPermissionEnum } from "../../../../../enums/ParentPermissionEnum";
import { PermissionActionEnum } from "../../../../../enums/PermissionActionEnum";
import { PermissionManager } from "../../../../../common/utilities/permission-manager";
import { AnalyticsCategory } from "../../../../../services/analytics.service";

import FormSection from "../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";
import EmptyTextHandler from "../../../../../resources-vue/vue-custom-elements/EmptyTextHandler/EmptyTextHandler.vue";
import FrequencyWatchHosForm from "../../FrequencyWatchHos/FrequencyWatchHosForm/FrequencyWatchHosForm.vue";
import ErrorMessageHandler from "../../../../../resources-vue/vue-custom-elements/ErrorMessageHandler/ErrorMessageHandler.vue";
import ScheduleVisit from "../../../../../resources-vue/vue-dialogs/ScheduleVisit/ScheduleVisit.vue";

export default defineComponent({
    components: {
        FormSection,
        EmptyTextHandler,
        FrequencyWatchHosForm,
        ErrorMessageHandler
    },
    props: {
        columns: {
            type: Number
        },
        frequencyItem: {
            type: Object
        },

        application: {
            type: Number
        },
        selectedAgency: {
            type: String
        },
        selectedBranches: {
            type: String
        }
    },
    data(vm) {
        return {
            _permissionManager: null as PermissionManager,
            _reportsService: null as ReportService,
            _taskService: null as TaskService,
            _navigationService: null as NavigationService,
            isEditRequested: false as boolean,
            isEditInProgress: false as boolean,
            isRowExpanded: false as boolean,
            isLoading: false as boolean,
            page: [] as any,
            loadingCount: 5 as number,
            dialogRef: null,
            isWeeklyRowExpanded: false as boolean,
            isError: false as boolean,
            freqyencyWatchWeeklyPagination: null,
            pageSize: 10 as number,
            formatDate
        };
    },

    provide() {
        return {
            dialogRef: computed(() => this.dialogRef)
        };
    },

    computed: {
        hasData() {
            return this.page.length > 0;
        }
    },

    created() {
        this._navigationService = Container.instance.get(NavigationService);
        this._taskService = Container.instance.get(TaskService);
        this._reportsService = Container.instance.get(ReportService);
        this._permissionManager = Container.instance.get(PermissionManager);
    },

    methods: {
        getFrequencyStatusName(value: number) {
            return Array.from(FrequencyStatuses.enumWithDescriptions.values()).filter(
                (status) => status.value === value
            )[0].name;
        },
        messageUser() {
            this.isEditRequested = true;
        },

        cancel() {
            this.isEditRequested = false;
        },

        async handlePatientNameClick(resource: any) {
            const isClinician = this._permissionManager.checkPermission(
                ParentPermissionEnum.clinician,
                PermissionActionEnum.canView
            );
            let redirectResponse = await this._navigationService.navigateToPatient({
                agencyId: this.selectedAgency,
                applicationId: this.application,
                isClinician: isClinician,
                patientId: resource.PatientId
            });
            let action = this.application === ApplicationEnum.AgencyCore ? "AxxessHomeHealth" : "AxxessHomeCare";
            this._navigationService.redirect(redirectResponse, {
                category: AnalyticsCategory.CentralCalendarNavigation,
                action
            });
        },

        async expandRow(frequencyItem?: any) {
            this.isRowExpanded = !this.isRowExpanded;
            if (this.isRowExpanded) {
                this.getWeeklyFrequencyWatch(frequencyItem);
            }
        },

        async getWeeklyFrequencyWatch(frequencyItem: any) {
            try {
                this.isLoading = true;
                this.isError = false;
                let payload: IFrequencyWatchWeeklyRequest = {
                    Application: this.application,
                    AccountId: this.selectedAgency,
                    UserId: "",
                    LocationIds: [this.selectedBranches],
                    StartDate: frequencyItem.StartDate,
                    EndDate: frequencyItem.EndDate,
                    Page: 1,
                    PageLength: 10,
                    TeamList: [],
                    LineOfService: 1,
                    IsUnder: null,
                    Disciplines: [frequencyItem.Discipline],
                    Tags: [],
                    SortBy: "patientLastName",
                    Order: "asc",
                    FrequencyStatuses: [],
                    PatientId: frequencyItem.PatientId
                };
                let response = (await this._reportsService.getFrequencyWatchWeekly(payload)) as any;
                this.page = response;
            } catch (e) {
                this.isError = true;
                console.error(PAGE_FAIL_RESPONSE);
            } finally {
                this.isLoading = false;
            }
        },

        expandWeeklyRow(frequencyItem?: any) {
            this.isWeeklyRowExpanded = !this.isWeeklyRowExpanded;
            if (this.isWeeklyRowExpanded) {
                const payload = {
                    start: frequencyItem.StartDate,
                    end: frequencyItem.EndDate,
                    patientIds: [frequencyItem.PatientId]
                };
                const tasks = this._taskService.getTasksByPatients(payload);
            }
        },

        openAddTaskForm(patient: any) {
            const visitDetails = {
                Application: this.application,
                AgencyId: this.selectedAgency,
                LocationIds: [this.selectedBranches],
                FirstName: patient.PatientName.split(",")[0],
                LastName: patient.PatientName.split(",")[1],
                AgencyName: "",
                Id: patient.PatientId
            };

            this.dialogRef = this.$dialog.open(ScheduleVisit, {
                props: {
                    modal: true,
                    showHeader: false
                },
                data: {
                    visitDetails
                }
            });
        }
    }
});
